/* Onixm theme helpers: favourites (wishlist), add-to-cart, toast. */
(function () {
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var KEY = 'onx-favs';

  function readFavs() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; }
  }
  function writeFavs(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
  }
  function paintFavs() {
    var favs = readFavs();
    document.querySelectorAll('[data-onx-fav]').forEach(function (btn) {
      var on = favs.indexOf(btn.getAttribute('data-onx-fav')) !== -1;
      btn.classList.toggle('is-on', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    document.querySelectorAll('[data-onx-fav-count]').forEach(function (el) {
      el.textContent = favs.length;
      el.hidden = favs.length === 0;
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-onx-fav]');
    if (!btn) return;
    e.preventDefault();
    var handle = btn.getAttribute('data-onx-fav');
    var favs = readFavs();
    var i = favs.indexOf(handle);
    if (i === -1) favs.unshift(handle); else favs.splice(i, 1);
    writeFavs(favs);
    paintFavs();
    document.dispatchEvent(new CustomEvent('onx:favs'));
  });

  function toast(message, linkLabel, linkUrl) {
    var el = document.querySelector('.onx-toast');
    if (!el) {
      el = document.createElement('div');
      el.className = 'onx-toast';
      el.setAttribute('role', 'status');
      document.body.appendChild(el);
    }
    el.innerHTML = '';
    var span = document.createElement('span');
    span.textContent = message;
    el.appendChild(span);
    if (linkLabel) {
      var a = document.createElement('a');
      a.href = linkUrl;
      a.textContent = linkLabel;
      el.appendChild(a);
    }
    el.classList.add('is-on');
    clearTimeout(el._t);
    el._t = setTimeout(function () { el.classList.remove('is-on'); }, 4000);
  }

  function addToCart(items) {
    return fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) {
        return r.json().then(function (d) {
          if (!r.ok) throw new Error(d.description || d.message || 'Erreur');
          return d;
        });
      })
      .then(function () { return fetch(ROOT + 'cart.js').then(function (r) { return r.json(); }); })
      .then(function (cart) {
        document.querySelectorAll('.onx-cart__count').forEach(function (c) { c.textContent = cart.item_count; });
        return cart;
      });
  }

  window.onx = { root: ROOT, readFavs: readFavs, paintFavs: paintFavs, toast: toast, addToCart: addToCart };
  paintFavs();
  document.addEventListener('DOMContentLoaded', paintFavs);
})();
